import React, { useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/OrderViewDetails.css";

import { plants } from "../../constant";
import ProductCard from "../../Components/Cards/ProductCard";
import ReactPaginate from "react-paginate";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function OrderViewDetails() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);

  const location = useLocation();
  const handlePageClick = async (data) => {
    setCurrentPage(data?.selected + 1);
  };

  return (
    <>
      <Header />
      <section className="plantingMixing-page">
        <div className="container">
          <div className="row">
            <div className="col-lg-3"></div>
            <div className="col-lg-6">
              <div className="detail_amount_total">
                <div className="main_heading">
                  <h2 className="main_title">Orders Details</h2>
                  <h4 className="main_number">#{location?.state?.id}</h4>
                </div>
                <div className="card_details">
                  <div className="details_head2">Product Detail</div>
                  <div className="allDetailCard">
                    {location?.state.order_detail.map((item, index) => {
                      return (
                        <div
                          key={index + 220}
                          className="all_booking_details mt-4"
                        >
                          <div className="Coneflower">
                            <img
                              src={`${ImageUrlRedux?.product_thumbnail_url}/${item?.product?.thumbnail}`}
                              className="img_plants_sub_orrder_view_details"
                              alt=""
                            />
                            <div className="quantityset">
                              <h4>{item?.product?.name}</h4>
                              <p>{JSON.parse(item?.product_details)?.slug}</p>
                              <p>{item?.variant}</p>
                              <p>Quantity: {item?.qty}</p>

                              {item?.delivery_date ? (
                                <h5 className="price">
                                  <span
                                    className="order-no"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Delivery Date : {item?.delivery_date?.value}
                                  </span>
                                </h5>
                              ) : null}

                              {item?.order_detail_addon_variant.length > 0 ? (
                                <>
                                  {item?.order_detail_addon_variant?.map(
                                    (item) => {
                                      return (
                                        <h5 className="status" key={item?.id}>
                                          <span>
                                            <label>Addon</label>
                                            <p className="m-0">
                                              {
                                                item?.addon_variants?.addon
                                                  ?.name
                                              }{" "}
                                              $
                                              {
                                                item?.addon_variants?.price
                                              }
                                            </p>
                                          </span>
                                        </h5>
                                      );
                                    }
                                  )}
                                </>
                              ) : null}

                              {item?.campaign_price ? (
                                <h5 className="status">
                                  <span>
                                    <label>Donation : </label> $
                                    {item?.campaign_price}
                                  </span>
                                </h5>
                              ) : null}
                            </div>
                          </div>
                          <div>
                            <p className="pricePlant">$ {item?.price}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="details_head2 head3">Order Detail</div>
                  <div className="pricingDetail">
                    <div className="row detailamount">
                      <div className="col-lg-8 col-sm-8 Datepara col-6 floatright">
                        <p>Date:</p>
                        <p>Subtotal:</p>
                        {/* <p>Tax fee:</p> */}
                        <p>Discount Coupon Code Applied </p>
                        <p>Discount Gift Code Applied</p>
                        <p>Shipping fee:</p>
                        <p>Shipping Address:</p>
                        <p>Total Amount</p>
                      </div>
                      <div className="col-lg-4 col-sm-4 Datenumber col-6 floatleft">
                        <p>{location?.state?.created_at.slice(0, 10)}</p>
                        <p>${location?.state?.order_amount}</p>
                        <p>-$ {location?.state?.discount_amount}</p>
                        <p>-$ {location?.state?.gift_certificate_price}</p>
                        {/* <p>${location?.state?.tax}</p> */}
                        <p>${location?.state?.shipping_amount}</p>
                        <p>{location?.state?.shipping?.address}</p>
                        <p>
                          {location?.state?.order_amount -
                            (location?.state?.gift_certificate_price +
								location?.state?.discount_amount)}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <div className="details_head2 head3">Shipment</div>.
									<div className="row detailamount">
										<div className="col-md-8 Datepara col-6">
											<p>Estmated Arrival:</p>
										</div>
										<div className="col-md-4 Datenumber col-6">
											<p>24 November</p>
										</div>
									</div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3"></div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default OrderViewDetails;
